import { reduce } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getKhattabatMatchingStore from "../../../../stores/khattabat-stores/matching-stores";

const MatchesFoundCount = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;

  const resultsNumber = reduce(
    () => getKhattabatMatchingStore().matchesIds.get().length,
    0
  );

  const selectedMatchesCount = reduce(
    () => getKhattabatMatchingStore().selectedMatchesCount.get(),
    0
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={1510}
      height={80}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={28}
        isSpan={true}
        text={`${i18n.get("RESULTS_NUMBER")}:`}
        style={{
          height: 50 * unitY,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        color={""}
      />

      <Et3Margin top={0} bottom={0} left={10} right={0} />

      <Et3Text
        fontFamily={"BOLD"}
        fontSize={28}
        isSpan={true}
        text={`${resultsNumber}`}
        style={{
          height: 50 * unitY,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: colors.all.red
        }}
        color={""}
      />

      {resultsNumber > 0 && (
        <>
          <Et3Margin top={0} bottom={0} left={35} right={0} />

          <Et3Text
            fontFamily={"LIGHT"}
            fontSize={28}
            isSpan={true}
            text={`${i18n.get("KHATTABAT_SELECTED_MATCHES")}:`}
            style={{
              height: 50 * unitY,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            color={""}
          />

          <Et3Margin top={0} bottom={0} left={10} right={0} />

          <Et3Text
            fontFamily={"BOLD"}
            fontSize={28}
            isSpan={true}
            text={`${selectedMatchesCount}`}
            style={{
              height: 50 * unitY,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: colors.all.red
            }}
            color={""}
          />

          <Et3Margin top={0} bottom={0} left={35} right={0} />

          <ET3Div
            isScrollable={false}
            isExtendable={false}
            fDirection="row"
            justifyContent="center"
            alignItems="center"
            withShadow={false}
            width={200}
            height={50}
            color={colors.all.blue}
            style={{
              borderRadius: 6,
              cursor: "pointer"
            }}
            onClick={() => {
              return getCorePopUpStore().openConfirmationPopUps(
                "KHATTABAT_MATCHING_RESULTS_POPUP"
              );
            }}
          >
            <Et3Text
              fontFamily={"BOLD"}
              fontSize={22}
              isSpan={true}
              text={i18n.get("KHATTABAT_SHOW_RESULTS")}
              style={{
                height: 50 * unitY,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: colors.all.white
              }}
              color={""}
            />
          </ET3Div>
        </>
      )}
    </ET3Div>
  );
});

export default MatchesFoundCount;
